import { jwtDecode } from 'jwt-decode';
import { clearExpectedUserId, matchesExpectedUserId, setExpectedUserId, setSkipAutoLogin } from './sessionIdentity';

let accessToken = '';
const url = import.meta.env.VITE_BACKEND_URL
  ? `${import.meta.env.VITE_BACKEND_URL}/v1/auth/manager-refresh-token`
  : 'http://localhost:5001/v1/auth/manager-refresh-token';

export const isExpired = (token: string) => {
  const { exp } = jwtDecode(token);
  if (exp) {
    return Date.now() >= exp * 1000;
  }
  return true;
};

export const getManagerAccessToken = () => {
  return accessToken;
};

export const setManagerAccessToken = (token: string) => {
  accessToken = token;
};
export const fetchManagerAccessToken = () => {
  const isEmbedded = window.self != window.top;
  const trustedHint = isEmbedded ? new URLSearchParams(window.location.search).get('expectedUserId') : null;

  return new Promise<{ accessToken: string; user: unknown }>((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ embedded: isEmbedded }),
    })
      .then(async (x) => {
        if (x.status !== 201) {
          setManagerAccessToken('');
          reject();
          return;
        }
        const { accessToken, user, userType } = await x.json();
        if (!matchesExpectedUserId(accessToken, trustedHint)) {
          clearExpectedUserId();
          setSkipAutoLogin();
          setManagerAccessToken('');
          resolve({ accessToken: '', user: null });
          return;
        }
        setExpectedUserId(accessToken);
        setManagerAccessToken(accessToken);
        resolve({ accessToken, user: { ...user, userType } });
      })
      .catch((err) => {
        setManagerAccessToken('');
        console.error('err', err);
        reject(err);
      });
  });
};
